module.exports = __webpack_public_path__ + "static/media/ci-sin-chip-serie.86a7b56f.mp4";